import { formatPrice } from "helpers/functions/pricing";
import React, { Component } from "react";
import { Table } from "react-bootstrap";

class Statement extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render () {
        const {
            data
        } = this.props;

        return (
            <Table className="statement">
                <thead>
                <tr>
                    <th style={{width: '300px'}}>Stage</th>
                    <th style={{width: '200px'}}>Entry</th>
                    <th style={{width: '100px'}}>Value</th>
                    <th style={{width: '50%'}}>Observations</th>
                </tr>
                </thead>
                <tbody>
                {data 
                ? data.map((item) => {
                    return (
                    <tr className={item.isBold ? 'table-bold': ''}>
                        <td>{item.stage}</td>
                        <td>{item.entry}</td>
                        <td>{formatPrice(item.value)}</td>
                        <td>
                            {item.observations}    
                            {
                                item.error &&
                                <div className="alert alert-danger" style={{borderRadius: '8px', margin: "10px 0 0"}}>
                                    {item.error}
                                </div>
                            }
                        </td>
                    </tr>
                    )
                    })
                :
                    <tr>
                    <td colSpan="4">There are no entries to show.</td>
                    </tr>
                }
                </tbody>
            </Table>
        )
    }
}

export default Statement;